module.exports = __webpack_public_path__ + "img/sheep.6472acde.png";